<template>
  <v-card
    flat
    color="transparent"
  >
    <v-card-text class="px-0 info--text wrap">
      <v-layout column>
        {{ hint }}
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hint() {
      const template = this.$t('userManagementCoadminHint');
      return template.replace(
        '{{ user }}',
        this.user.first_name + ' ' + this.user.last_name
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UserManagement/UserManagementCoadminHint.vue